/* eslint-disable react-hooks/exhaustive-deps */

import * as Icon from 'base/ui/components/Icons';

import { Form, Radio, Spin, message } from 'antd';
import { SearchForm, SearchItem } from 'pages/Components/SearchBox';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { catalogPresenter, catalogStore, categoryMdPresenter, categoryMdStore, userStore } from 'stores/root_store';

import BoxContainer from 'base/ui/components/BoxContainer';
import CustomButton from 'base/ui/components/Button';
import CustomBreadcrumb from 'base/ui/components/CustomBreadcrumb';
import CustomInput from 'base/ui/components/CustomInput';
import CustomSelect from 'base/ui/components/CustomSelect';
import CustomInputNumber from 'base/ui/components/CustomInputNumber';
import { DataCatalog } from 'services/RawData/catalog_services';
import { usePermission } from 'hooks/usePermission';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { SYSTEM_TITLE } from 'utils/constants';
import { removeEmptyValues } from 'utils/transformHelper';

const createAddUpdateCategory = () => {
  return observer(() => {
    const { t } = useTranslation();

    const { id: idParams } = useParams();
    let pageTitle = '';

    if (idParams) {
      usePermission('EDIT');
      pageTitle = t('page-title.update');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    } else {
      usePermission('CREATE');
      pageTitle = t('page-title.create');
      document.title = pageTitle + ' - ' + SYSTEM_TITLE;
    }

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [listCategoryType, setListCategoryType] = useState<DataCatalog[]>([]);
    let isSaveAndContinue = false;
    const [form] = Form.useForm();

    const getDetail = async (categoryId: string) => {
      await categoryMdPresenter.getCategoryById(categoryMdStore, categoryId);
      if (categoryMdStore.detailResponse.isSuccess) {
        form.setFieldsValue(categoryMdStore.detailResponse.data);
        // Nếu detail không có categoryType, set default (phần tử đầu tiên)
        if (!categoryMdStore.detailResponse.data?.categoryType) {
          const categoryTypeList = catalogStore.searchDropdownCatalogResponse.data || [];
          if (categoryTypeList.length > 0) {
            const first = categoryTypeList[0];
            if (first) {
              form.setFieldsValue({ categoryType: first.catalogCode });
            }
          }
        }
        setLoading(false);
      } else {
        navigate('/MasterData/Category');
      }
    };

    // Lấy danh sách CategoryType từ catalog
    const getListCategoryType = async () => {
      await catalogPresenter.searchDropdownCatalog(catalogStore, 'CategoryType');
      if (catalogStore.searchDropdownCatalogResponse.isSuccess) {
        setListCategoryType(catalogStore.searchDropdownCatalogResponse.data);
        // Set default value (phần tử đầu tiên) nếu chưa có giá trị
        const currentValue = form.getFieldValue('categoryType');
        if (!currentValue) {
          const first = catalogStore.searchDropdownCatalogResponse.data?.[0];
          if (first) {
            form.setFieldsValue({ categoryType: first.catalogCode });
          }
        }
      }
    };

    useEffect(() => {
      const loadData = async () => {
        await getListCategoryType();
        if (idParams) {
          setLoading(true);
          await getDetail(idParams);
        }
      };
      loadData();
    }, []);

    const onFinish = async (values: any) => {
      setLoading(true);
      removeEmptyValues(values);
      if (!idParams) {
        await categoryMdPresenter.createCategory(categoryMdStore, values);
        if (categoryMdStore.crudResponse.isSuccess) {
          message.success(categoryMdStore.crudResponse.message);
          if (!isSaveAndContinue) {
            navigate('/MasterData/Category');
          }
          form.resetFields();
        }
      } else {
        await categoryMdPresenter.updateCategory(categoryMdStore, idParams, values);
        if (categoryMdStore.crudResponse.isSuccess) {
          message.success(categoryMdStore.crudResponse.message);
          if (!isSaveAndContinue) {
            navigate('/MasterData/Category');
          }
        }
      }
      setLoading(false);
    };

    const initialValue = {
      actived: true,
    };

    function ButtonCreateUpdate() {
      return (
        <>
          <CustomButton
            icon={<Icon.Download className="!fill-[#262626]" />}
            htmlType="submit"
            disabled={loading}
            loading={loading}
            onClick={() => {
              isSaveAndContinue = false;
              form.submit();
            }}
          >
            {t('btn.save')}
          </CustomButton>
          <CustomButton
            type="primary"
            icon={<Icon.Download />}
            disabled={loading}
            loading={loading}
            onClick={() => {
              isSaveAndContinue = true;
              form.submit();
            }}
          >
            {idParams ? t('btn.save-update') : t('btn.save-continue-create')}
          </CustomButton>
        </>
      );
    }

    return (
      <>
        <div className="flex flex-col h-full">
          <CustomBreadcrumb
            pagetitle={[
              { title: t('masterdata.category.title'), link: '/MasterData/Category' },
              { title: pageTitle, link: idParams ? `/MasterData/Category/${idParams}` : '/MasterData/Category/create' },
            ]}
            extra={
              <div className="custom__mobile--save flex space-x-2">
                {!idParams && userStore.userPermission?.includes('CREATE') ? <ButtonCreateUpdate /> : null}
                {idParams && userStore.userPermission?.includes('EDIT') ? <ButtonCreateUpdate /> : null}
              </div>
            }
          />
          <BoxContainer fullHeight>
            <Spin spinning={loading}>
              <SearchForm initialValues={idParams ? {} : initialValue} form={form} onFinish={onFinish}>
                <SearchItem
                  label={t('masterdata.category.category-code')}
                  name="categoryCode"
                  rules={[{ required: true, message: 'Hãy nhập mã danh mục' }]}
                >
                  <CustomInput disabled={idParams ? true : false} />
                </SearchItem>
                <SearchItem label={t('masterdata.category.category-name')} name="categoryName">
                  <CustomInput />
                </SearchItem>
                {/* Loại danh mục */}
                <SearchItem label={t('masterdata.category.category-type')} name="categoryType">
                  <CustomSelect
                    options={listCategoryType}
                    fieldNames={{ label: 'catalogName', value: 'catalogCode' }}
                    allowClear
                  />
                </SearchItem>
                {/* Khối lượng GPMT */}
                <SearchItem label={t('masterdata.category.khoi-luong-gpmt')} name="khoiLuongGpmt">
                  <CustomInputNumber controls={false} className="!w-full" />
                </SearchItem>
                <SearchItem className="m-0 mb-2" name={'actived'} label={t('masterdata.category.status')}>
                  <Radio.Group>
                    <Radio value={true}>{t('radio-btn.active')}</Radio>
                    <Radio value={false}>{t('radio-btn.in-active')}</Radio>
                  </Radio.Group>
                </SearchItem>
              </SearchForm>
            </Spin>
          </BoxContainer>
        </div>
      </>
    );
  });
};

export default createAddUpdateCategory;


